import { useState } from 'react';
import { useI18n } from '../i18n';
import { Button } from './ui';

/**
 * Affiche un secret que le serveur ne renverra jamais plus.
 *
 * Le bandeau est volontairement insistant et ne disparaît que sur action explicite :
 * un token d'appairage ou un code d'invitation perdu ne se récupère pas, il se
 * régénère — ce qui, pour un token, oblige à repasser sur tous les nœuds du réseau.
 */
export function SecretReveal({
  secret,
  intro,
  onAcknowledge,
}: {
  secret: string;
  intro: string;
  onAcknowledge: () => void;
}) {
  const { t } = useI18n();
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(secret);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // Presse-papiers refusé (contexte non sécurisé) : la valeur reste sélectionnable.
      setCopied(false);
    }
  };

  return (
    <div className="banner banner-secret" role="alert">
      <div className="secret-head">
        <strong>{intro}</strong>
        <span className="badge badge-warn">{t('secret.shownOnce')}</span>
      </div>
      <code className="secret-value">{secret}</code>
      <p className="hint">{t('secret.warning')}</p>
      <div className="row">
        <Button variant="primary" onClick={() => void copy()}>
          {copied ? t('common.copied') : t('common.copy')}
        </Button>
        <Button onClick={onAcknowledge}>{t('secret.acknowledge')}</Button>
      </div>
    </div>
  );
}
